module.exports = __webpack_public_path__ + "img/mastercard.460518f.svg";